<template>
  <v-card class="pa-4" flat>
  <marketplace-card-slider v-model="selectedMarketplace" class="pa-3 mb-5"/>
    <div class="d-flex justify-space-between align-center mb-4">
      <v-btn
        @click="fetchReports"
        outlined
        color="info"
        class="pa-2 rounded-lg"
        :loading="loading"
      >
        <v-icon left size="20">mdi-refresh</v-icon>
        بروزرسانی لیست
      </v-btn>
    </div>

    <!-- جدول نمایش گزارش‌ها -->
    <vue-table
      :data="reports"
      :headers="tableColumns"
      :loading.sync="loading"
      @change="onPagination"
    >
      <!-- اسلات فیلترهای یکپارچه جدول -->
      <template v-slot:filters="{ props, perPage }">
        <v-row no-gutters class="mb-4">
          <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select
              v-model="props.length"
              :items="perPage"
              class="rounded-lg"
              dense
              hide-details
              :label="'تعداد در هر صفحه'"
              outlined
              @change="() => onPagination(props)"
            />
          </v-col>

          <!-- <v-col class="pa-2" cols="12" lg="3" md="3">
            <v-select
              v-model="props.status"
              :items="statusOptions"
              label="وضعیت"
              dense
              hide-details
              outlined
              clearable
              class="rounded-lg"
              @change="() => onPagination(props)"
            ></v-select>
          </v-col> -->

          <v-col class="pa-2" cols="12" lg="3" md="3">
            <v-select
              v-model="props.type"
              :items="typeOptions"
              label="نوع اجرا"
              dense
              hide-details
              outlined
              clearable
              class="rounded-lg"
              @change="() => onPagination(props)"
            ></v-select>
          </v-col>
        </v-row>
      </template>
      <template v-slot:index="{item}">               
        {{ persian(item.index + 1 + (reports?.current_page - 1) * reports?.per_page) }}
      </template>

      <!-- اسلات زمان -->
      <template v-slot:started_at="{item}">
        {{ jalalian(item.started_at,"datetime") }}
      </template>
      
      <!-- اسلات وضعیت -->
       <template v-slot:job_type="{ item }">
        <v-chip
          :color="getTypeJobColor(item.status).bg"
          :text-color="getTypeJobColor(item.status).text"
          small
          class="font-weight-bold"
        >
          {{ getTypeJobText(item.status) }}
        </v-chip>
      </template>
      
      <!-- اسلات نوع -->
      <template v-slot:type="{ item }">
        <v-chip
          :color="getTypeColor(item.type).bg"
          :text-color="getTypeColor(item.type).text"
          small
          class="font-weight-bold"
        >
          {{ getTypeText(item.type) }}
        </v-chip>
      </template>
      
      <!-- اسلات درصد پیشرفت -->
   <template v-slot:progress_percent="{ item }">
        <div class="d-flex align-center">
          <span class="mr-2">{{ persian(calculateProgress(item)) }}%</span>
          <v-progress-linear
            :value="calculateProgress(item)"
            color="primary lighten-1"
            height="8"
            rounded
          ></v-progress-linear>
        </div>
      </template>

      <!-- اسلات عملیات -->
      <template v-slot:action="{ item }">
        <action-buttons :data="item" :meta="metabutton(item)" />
      </template>
    </vue-table>

    <!-- مدال جزئیات -->
   <custom-popup
      v-model="showDialog"
      :cons="{ title: 'جزئیات اجرای شماره ' + (selectedReport ? selectedReport.id : '') }"
      max-width="500"
      hide-confirm
      :reloadable="true"
      @reload="loadSingleReport(selectedReport.id)"
      @close="showDialog = false"
    >
      <v-card class="pa-4" flat v-if="selectedReport">
        <v-list dense>
          <v-list-item>
            <v-list-item-content>شناسه:</v-list-item-content>
            <v-list-item-content class="align-end">{{ selectedReport.id }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>وضعیت:</v-list-item-content>
            <v-list-item-content class="align-end">
              <v-chip 
                :color="getStatusColor(selectedReport.status).bg" 
                :text-color="getStatusColor(selectedReport.status).text" 
                small 
                class="font-weight-bold"
              >
                {{ getStatusText(selectedReport.status) }}
              </v-chip>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>نوع اجرا:</v-list-item-content>
            <v-list-item-content class="align-end">{{ getTypeText(selectedReport.type) }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>زمان شروع:</v-list-item-content>
            <v-list-item-content class="align-end" dir="ltr">{{ jalalian(selectedReport.started_at,"datetime") }}</v-list-item-content>
          </v-list-item>
          <v-divider class="my-2"></v-divider>
          <v-list-item>
            <v-list-item-content>کل رکوردها:</v-list-item-content>
            <v-list-item-content class="align-end">{{ persian(selectedReport.total || 0) }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>پردازش شده:</v-list-item-content>
            <v-list-item-content class="align-end">{{ persian(selectedReport.processed || 0) }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>باقی‌مانده:</v-list-item-content>
            <v-list-item-content class="align-end">{{ persian((selectedReport.remaining || 0)) }}</v-list-item-content>
          </v-list-item>
        </v-list>
        
        <div class="mt-4">
          <div class="mb-1 text-center font-weight-bold">{{ persian(selectedReport.progress_percent) }}%</div>
          <v-progress-linear
            :value="selectedReport.progress_percent"
            color="primary"
            height="15"
            striped
            rounded
          ></v-progress-linear>
        </div>
      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";
import MarketplaceCardSlider from "../../components/MarketplaceCardSlider.vue";

export default {
  name: "RepricerReportTab",
  components: { ActionButtons,MarketplaceCardSlider },
  props:{
    store_id:{ type:Number, default:null},
  },
  data() {
    return {
      selectedMarketplace: null,
      items: [
        { type: 'digikala', component: 'ProductVarient' },
        { type: 'divar', component: 'numbersList' },
        { type: 'physical_store', component: 'PhysicalProductList' },
        { type: 'woocommerce', component: 'ProductList' },
      ],

      loading: false,
      showDialog: false,
      reports: [],
      selectedReport: null,
      
      statusOptions: [
        { text: "همه", value: null },
        { text: "در حال اجرا", value: "running" },
        { text: "تکمیل شده", value: "finished" },
        { text: "متوقف/خطا", value: "stopped" },
      ],
      
      typeOptions: [
        { text: "همه", value: null },
        { text: "زمان‌بندی", value: "scheduled" },
        { text: "دستی", value: "manual" },
        { text: "بروزسانی خودکار", value: "auto_update" },

      ],

      tableProps: {
        page: 1,
        length: 10,
        // status: null,
        type: null,
        // min_progress: null,
        store_id:null,
      },
    };
  },

  computed: {
    activeComponent() {
      if (!this.selectedMarketplace || !this.selectedMarketplace.type) return null;
      const found = this.items.find((x) => x.type === this.selectedMarketplace.type);
      return found ? found.component : null;
    },
    tableColumns() {
      return [
        { value: "index", text: "ردیف", align: "center", sortable: true },
        { value: "id", text: "شناسه", align: "center", sortable: true },
        // { value: "status", text: "وضعیت", align: "center", sortable: true },
        { value: "type", text: "نوع", align: "center", sortable: false },
        { value: "progress_percent", text: "پیشرفت", align: "center", sortable: false, width: "150px" },
        { value: "started_at", text: "زمان شروع", align: "center", sortable: true },
        {value:'job_type',text:'نوع صف اجرا', align:"center",sortable: true},
        { value: "action", text: "عملیات", align: "center", sortable: false, event: "actions" },
      ];
    },
  },

  mounted() {
    this.fetchReports();
  },
  watch:{
    selectedMarketplace: {
      handler(val) {
        this.tableProps.store_id=val.store_id;
        this.fetchReports();
      },
      deep: true
    }
  },
  methods: {
    calculateProgress(item) {
      if (!item || !item.total_variants) return 0;
      const total = Number(item.total_variants);
      const processed = Number(item.processed_variants) || 0;
      
      if (total === 0) return 0;
      
      const percent = (processed / total) * 100;
      return Math.round(percent);
    },
    metabutton(item) {
      const buttons = [
        {
          name: "view",
          label: "مشاهده جزئیات",
          icon: "eye",
          class: "btn-outline-info rounded-pill",
          action: this.actions,
        },
      ];

      if (item.status === "running") {
        buttons.push({
          name: "stop",
          label: "توقف",
          icon: "stop",
          class: "btn-outline-danger rounded-pill",
          action: this.actions,
        });
      }

      return { buttons };
    },

    getStatusColor(status) {
      if (!status) return { bg: "grey lighten-4", text: "grey darken-2" };
      const s = status.toLowerCase();
      if (s === "running") return { bg: "blue lighten-4", text: "blue darken-3" };
      if (s === "finished") return { bg: "green lighten-4", text: "green darken-3" };
      if (s === "stopped" || s === "failed") return { bg: "red lighten-4", text: "red darken-3" };
      return { bg: "grey lighten-4", text: "grey darken-2" };
    },
    
    getStatusText(status) {
      if (!status) return "نامشخص";
      const s = status.toLowerCase();
      if (s === "running") return "در حال اجرا";
      if (s === "finished") return "تکمیل شده";
      if (s === "stopped" || s === "failed") return "متوقف شده";
      return "نامشخص";
    },

    getTypeColor(type) {
      if (!type) return { bg: "grey lighten-4", text: "grey darken-2" };
      const s = type.toLowerCase();
      if (s === "sync") return { bg: "cyan lighten-4", text: "cyan darken-4" }; 
      if (s === "manual") return { bg: "warning lighten-4", text: "warning darken-4" };
      return { bg: "grey lighten-4", text: "grey darken-2" };
    },
    getTypeJobColor(type){
      if (!type) return { bg: "grey lighten-4", text: "grey darken-2" };
      const s = type.toLowerCase();
      if (s === "scheduled") return { bg: "cyan lighten-4", text: "cyan darken-4" }; 
      if (s === "repricing") return { bg: "warning lighten-4", text: "warning darken-4" };
      return { bg: "grey lighten-4", text: "grey darken-2" };
    },
    getTypeJobText(type) {
      if (!type) return "نامشخص";
      const s = type.toLowerCase();
      if (s === "sync") return "آپدیت تنوع";
      if (s === "repricing") return "بررسی قیمت";
      return "نامشخص";
    },

    
    getTypeText(type) {
      if (!type) return "نامشخص";
      const s = type.toLowerCase();
      if (s === "scheduled") return "زمان‌بندی";
      if (s === "manual") return "دستی";
      return "نامشخص";
    },

    fetchReports() {
      this.loading = true;
      const params = { ...this.tableProps };
      this.$api
        .get("/v1/digikala/repricer/report-list", { params })
        .then(({ data }) => {
          this.reports = data.data || data;
        })
        .catch(() => {
          this.$toast.error("خطا در دریافت لیست گزارش‌ها");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onPagination(e) {
      if (e && typeof e === 'object' && !Array.isArray(e)) {
        this.tableProps = { ...this.tableProps, ...e };
        if ('status' in e || 'type' in e ) {
          this.tableProps.page = 1;
        }
      }
      this.fetchReports();
    },

    actions(data, type) {
      if (type === "view") {
        this.loadSingleReport(data.id);
      } else if (type === "stop") {
        this.stopJob(data.id);
      }
    },

    loadSingleReport(id) {
      this.$api
        .get(`/v1/digikala/repricer/report/${id}`)
        .then(({ data }) => {
          this.selectedReport = data.data || data; 
          this.showDialog = true;
        })
        .catch(() => {
          this.$toast.error("خطا در دریافت جزئیات");
        });
    },
    

async stopJob(id) {
  const confirm = await this.$modal.yesNo("آیا از توقف این اجرا اطمینان دارید؟");
  if (!confirm) return;

  this.loading = true;
  try {
    await this.$api.post(`/v1/digikala/repricer/stop/${id}`);
    this.$toast.success("دستور توقف با موفقیت ارسال شد");

    await this.fetchReports();

    if (this.selectedReport && this.selectedReport.id === id) {
      await this.loadSingleReport(id);
    }
  } catch (e) {
    this.$toast.error("خطا در توقف عملیات");
  } finally {
    this.loading = false;
  }
},
  },
};
</script>
